







































































































































































interface curAccount {
    addtax: string;
    accountBookId: number;
    startPeriod: string;
    endPeriod: string;
}
interface ProductionList {
    accountBookId: number;
    collectionType: number;
    cost: string;
    declareDate: null | string;
    endPeriod: string;
    id: null | string | number;
    income: string;
    isMonthOperating: number;
    profit: string;
    startPeriod: string;
    writtenDate: null | string;
    employeeList: []
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";

import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
    }
})
export default class ProductionOperationTax extends Vue {
    curAccount: curAccount = {
        addtax: this.$store.state.accountBook.addtax,
        accountBookId: this.$store.state.accountBook.id,
        startPeriod: "",
        endPeriod: ""
    };
    activeTab: string = "";
    // quarter: number = 0;
    // collection: number = 0;
    incomeList: any | {} = {};
    newRow = {
        id: "",
        name: "",
        percentage: "",
        isSix: true
    };
    nameList: any[] = [];

    mounted() {
        this.getName()
    }
    addRow() {
        if (
            (this.newRow.id !== null || this.newRow.id != "") &&
            (this.newRow.percentage != "")
        ) {
            this.incomeList.employeeList.push(this.newRow);
            this.newRow = {
                id: "",
                name: "",
                percentage: "",
                isSix: true
            };
            this.changeList();
        } else {
            this.$message.warning("亲，请填写完整数据！");
        }
    }
    deleteRow(id: string) {
        for (let i = 0; i < this.incomeList.employeeList.length; i++) {
            if (this.incomeList.employeeList[i].id === id) {
                this.incomeList.employeeList.splice(i, 1)
            }
        }
        this.$nextTick(() => {
            this.changeList();
        })
    }
    getName() {
        Vue.axios
            .post(`dim/account/find`, {
                accountBookId: this.$store.state.accountBook.id,
                dimAccountType: "员工"
            })
            .then(res => {
                this.nameList = res.data.dimEmployeeList
            });
    }
    // 选择时间
    changeDate(val: string, lastVal: string) {
        this.curAccount.startPeriod = val;
        if (this.$store.state.accountBook.taxFormDto.isIncomeOperatingMonth === 0) {
            this.curAccount.endPeriod = lastVal;
        } else {
            this.curAccount.endPeriod = val;
        }
        this.fetchData();
    }

    // 表格数据
    curData: any = null;
    fetchData() {
        Vue.axios
            .get(`incometaxdeclarationoperatings?accountBookId=${this.$store.state.accountBook.id}&period=${this.curAccount.endPeriod}`)
            .then(res => {
                res.data.employeeList.forEach((row: any) => {
                    if (row.isSix) {
                        row.isSix = +row.isSix === 0 ? false : true;
                    }
                })
                this.incomeList = res.data;
            });
    }
    // 切换纳税申报表
    changeType(val: number) {
        if (val === 2) this.fetchData();
        else if (val === 0) this.$router.push({ path: "/declaration" });
    }
    // 修改内容
    changeList() {
        let list = this.incomeList
        list.employeeList.forEach((row: any) => {
            row.isSix = row.isSix ? "1" : "0"
        })
        Vue.axios
            .post(`incometaxdeclarationoperatings?accountBookId=${this.$store.state.accountBook.id}&period=${this.curAccount.endPeriod}`, list)
            .then(res => {
                this.fetchData();
            });
    }
    // 重置
    reset() {
        let lists = this.incomeList;
        lists.employeeList.forEach((row: any) => {
            row.isSix = row.isSix ? "1" : "0"
        });
        Vue.axios
            .delete(`incometaxdeclarationoperatings?accountBookId=${this.$store.state.accountBook.id}&period=${this.curAccount.endPeriod}`,{ data:lists })
            .then(res => {
                this.fetchData();
            });
    }

    focusInput(event: FocusEvent) {
        (<HTMLInputElement>event.target).select();
    }
}
